import PropTypes from 'prop-types';
import FJAiVideoDubRightStatusBox from '../view/FJAiVideoDubRightStatusBox';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub';
import FJConstant from '../../../../constants/FJConstant';

const FJAiVideoDubRightStatusBoxContainer = ({ isShow }) => {
    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const status = useSelector(state => state.common.taskStatus);
    const thumbnailUrl = useSelector(state => state.aiVideoDub.thumbnailUrl);
    const progress = useSelector(state => state.aiVideoDub.progress);
    const generateAllTime = useSelector(state => state.aiVideoDub.generateAllTime);

    const cancel = useCallback(() => {
        dispatch(FJActionAiVideoDub.cancelAction());
    }, [dispatch]);

    const retry = useCallback(() => {
        dispatch(FJActionAiVideoDub.retryAction());
    }, [dispatch]);

    return (
        <FJAiVideoDubRightStatusBox
            isShow={isShow && headerTabIndex === FJConstant.CREATIONS}
            status={status}
            thumbnailUrl={thumbnailUrl}
            progress={progress}
            generateAllTime={generateAllTime}
            cancel={cancel}
            retry={retry}
        />
    );
};

FJAiVideoDubRightStatusBoxContainer.propTypes = {
    isShow: PropTypes.bool.isRequired,
};

export default FJAiVideoDubRightStatusBoxContainer;
